import 'apps/pathways/styles/start/header.scss';
import React, { Fragment } from 'react';
import { resolve } from 'library/helpers/path-resolver';
import { NavLink, Link } from 'library/util/core-router';
import PropTypes from 'prop-types';
import withConfig from 'util/hoc/with-config';
import { ShimmyZone } from 'library/components/shimmy';
import withResize from 'library/hoc/on-window-resize';
import ComponentIfNotNull from 'library/components/if-not-null';
import { overAllInstructions } from 'apps/pathways/services/page-instructions';

class Header extends React.Component {
  static defaultProps = {
    step: 1
  }

  static propTypes = {
    step: PropTypes.number.isRequired,
    steps: PropTypes.arrayOf(PropTypes.object),
    windowWidth: PropTypes.number,
    pathwayId: PropTypes.sting,
    updatePathway: PropTypes.func,
    configuration: PropTypes.object,
    redirectStep: PropTypes.func
  }

  mapNavigation = (step, i) => (
    <Fragment>
      <span className="pathways-start-header-navigation-divider">
        →
      </span>
      <NavLink onClick={() => this.props.redirectStep(i)} aria-label={step.label} to={`/pathways/start/${i+1}`}>
        { step.label }
      </NavLink>
    </Fragment>
  )

  render() {
    const {
      step,
      steps,
      windowWidth,
      pathwayId,
      updatePathway,
      configuration
    } = this.props;

    const allowPathway = resolve(configuration, 'apps/pathways/configuration/pathway', true);

    return (
      <div role="banner" className="pathways-start-header">
        <div role="navigation" className="pathways-start-header-navigation">
          {
            windowWidth >= 800
              ? (
                <div className="pathways-start-header-navigation-inner">
                  <span aria-label={overAllInstructions} tabIndex="0" className="pathways-start-header-navigation-label">
                    PATHWAYS
                  </span>
                  {
                    steps.map(this.mapNavigation)
                  }
                  { pathwayId == '' || !allowPathway ? null: <button onClick={() => updatePathway()}> Regenerate Pathway </button> }
                </div>
              )
              : (
                <div className="pathways-start-header-navigation-wrapper">
                  <ComponentIfNotNull
                    component={Link}
                    to={`/pathways/start/${step-1}`}
                    nullComponent="span"
                    className="pathways-start-header-navigation-small"
                  >
                    {resolve(steps, `${step-2}/label`, null)}
                  </ComponentIfNotNull>
                  { pathwayId == '' || !allowPathway ? null: <button onClick={() => updatePathway()}> Regenerate Pathway </button> }
                  <ComponentIfNotNull
                    component={Link}
                    to={`/pathways/start/${step+1}`}
                    nullComponent="span"
                    className="pathways-start-header-navigation-small"
                  >
                    {resolve(steps, `${step}/label`, null)}
                  </ComponentIfNotNull>
                </div>
              )
          }
        </div>
        <div aria-hidden className="pathways-start-header-number">
          { step }
        </div>
        <div className="pathways-start-header-prev">
        </div>
        <div className="pathways-start-header-body">
          <ShimmyZone namespace="pathways-start-header"/>
        </div>
        <div className="pathways-start-header-next">
        </div>
      </div>
    );
  }
}

export default withConfig(withResize(Header));
